export class Search{
    public word = "";
}
export class Provisional{
  public word = "";
}
